module.exports = __webpack_public_path__ + "img/cn-ti.5be2430d.svg";